import { Children, useEffect, useRef, useState, type ReactNode } from 'react';

export function CourtCarousel({ children, label, previousLabel, nextLabel, hint }: { children: ReactNode; label: string; previousLabel: string; nextLabel: string; hint: string }) {
  const courtCount = Children.count(children);
  const hasPaging = courtCount > 1;
  const track = useRef<HTMLDivElement>(null);
  const [edges, setEdges] = useState({ start: true, end: true });
  useEffect(() => {
    const element = track.current;
    if (!element) return;
    element.scrollLeft = 0;
    const update = () => setEdges({ start: element.scrollLeft <= 1, end: element.scrollLeft + element.clientWidth >= element.scrollWidth - 1 });
    const observer = new ResizeObserver(update);
    observer.observe(element);
    element.addEventListener('scroll', update);
    update();
    return () => { observer.disconnect(); element.removeEventListener('scroll', update); };
  }, [children]);
  const move = (direction: number) => {
    const element = track.current;
    if (element) element.scrollBy({ left: direction * element.clientWidth, behavior: 'smooth' });
  };
  return <section className={`court-carousel${hasPaging ? ' court-carousel--paged' : ''}`} aria-label={label}>
    {hasPaging && <div className="court-carousel__controls">
      <button type="button" className="button button--small button--quiet" disabled={edges.start} onClick={() => move(-1)} aria-label={previousLabel}>←</button>
      <p className="court-carousel__hint"><strong>{label}: {courtCount}</strong>{(!edges.start || !edges.end) && <span>{hint}</span>}</p>
      <button type="button" className="button button--small button--quiet" disabled={edges.end} onClick={() => move(1)} aria-label={nextLabel}>→</button>
    </div>}
    <div className="court-carousel__track" ref={track} tabIndex={0} role="region" aria-label={label}>{children}</div>
  </section>;
}
